<template>
  <div>
    <div
      :ref="controlRef"
      :title="internalText"
      :style="{
        height: !isNaN(height) ? height + 'px' : height,
        width: !isNaN(width) ? width + 'px' : width,
      }"
    >
      <div
        v-show="editingMode"
        class="flex items-center w-full h-full"
      >
        <div
          class="ms-input flex w-full"
          :class="{
            isValid: errorProvider.isValid,
            'input-disabled': disabled,
          }"
        >
          <ms-icon
            v-if="icon && !iconAfter"
            :icon="icon"
            class="p-l-8"
            @click="
              focusInput();
              $emit('icon-click');
            "
          />
          <input
            :ref="controlFocusRef"
            v-model="internalText"
            :maxlength="maxLength"
            class="ms-input-item"
            :class="{'italic-place':isPlaceholderItalic,'gray-place':isPlaceholderGray}"
            :placeholder="placeholder"
            :disabled="disabled"
            :readonly="readOnly"
            :autofocus="autofocus"
            :tabindex="tabindex"
            :type="typeInput"
            :style="styleInput"
            v-on="listeners"
            @input="onChangeValue"
          >
          <ms-icon
            v-if="icon && iconAfter"
            :icon="icon"
            class="m-l-8"
            @click="
              focusInput();
              $emit('icon-click');
            "
          />
          <!-- <ms-tooltip v-if="!disabled && errorProvider.isValid" :showTooltips="false">
            <div class="icon-input" v-if="!disabled && errorProvider.isValid">
              <div class="mi mi-20 mi-icon-error"></div>
            </div>
          </ms-tooltip> -->
        </div>
        <div
          v-if="editable"
          class="flex m-l-8"
        >
          <ms-icon
            icon="mi-file-green"
            :tooltip-content="i18n.tc('i18nCommon.Save')"
            @click="saveEditMode"
          />
          <ms-icon
            icon="mi-circle-close-red"
            :tooltip-content="i18n.tc('i18nCommon.Cancel2')"
            @click="closeEditMode"
          />
        </div>
      </div>
      <div
        v-show="editable && !editingMode"
        class="flex"
        @dblclick="onDoubleClick"
      >
        <ms-text-border class="text-border">
          <slot name="custom-text">
            <span :title="internalText">{{ internalText }}</span>
          </slot>
          <template #icon>
            <ms-icon
              v-if="permission"
              icon="mi-pencil"
              :tooltip-content="i18n.tc('i18nCommon.Edit')"
              @click="clickEditBtn"
            />
            <ms-icon
              v-if="!permission"
              icon="mi-lock"
            />
          </template>
        </ms-text-border>
      </div>
    </div>
    <p
      v-if="
        !disabled &&
          errorProvider.isValid &&
          ((editable && editingMode) || !editable)
      "
      :class="{ 'text-error': errorProvider.isValid }"
    >
      {{ errorProvider.message }}
    </p>
  </div>
</template>
<script>
import msBaseComponent from "@/components/controls/msbase/msBaseComponent.vue";
import i18n from "@/i18ns/i18n.js";
import { MsControlRef,MsControlFocusRef } from "@/models/enums/MsControlRefConst.js";

export default {
  name: "MsInput",
  extends: msBaseComponent,
  props: {
    /**
     * V-model bắn ra ngoài binding 2 chiều
     */
    value: {
      default: '',
      type: [Number, String],
    },

    /**
     * Hiện thị chũ mờ ở dưới ô input
     * Created by LTDAT(22.06.2020)
     */
    placeholder: {
      default: '',
      type: [Number, String],
    },

    /**
     * placeholder có nghiêng không
     * Created by THNhat(23.02.2022)
     */
    isPlaceholderItalic: {
      type: Boolean,
      default: false,
    },

    /**
     * placeholder có màu xám không không
     * Created by THNhat(23.02.2022)
     */
    isPlaceholderGray: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      default: false,
      type: [Boolean, String],
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    //class chứa icon
    icon: {
      default: null,
      type: String,
    },
    //input chỉ đọc không cho nhập
    readOnly: {
      default: false,
      type: Boolean,
    },
    tabindex: {
      default: 1,
      type: [String, Number],
    },
    maxLength: {
      default: 1024,
      type: [Number, String],
    },
    height: {
      type: [String, Number],
      default: 36,
    },
    width: {
      type: [String, Number],
      default: "auto",
    },
    iconAfter: {
      type: [String, Boolean],
      default: false,
    },
    typeInput: {
      type: String,
      default: "text",
    },
    styleInput: {
      type: String,
      default: "",
    },
    editable: {
      type: Boolean,
      default: false,
    },
    paramValidate: Object,
    permission: {
      type: Boolean,
      default: true,
    },
    // Có reset validate khi giá trị thay đổi không
    isResetValidate: {
      type: Boolean,
      default: true,
    },
    globalPopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      i18n: i18n,
      internalText: this.value,
      focused: false,
      // set chế độ edit = fasle khi editable = true
      editingMode: !this.editable,
      oldValue: null,
      controlRef: MsControlRef.MsInput,
      controlFocusRef: MsControlFocusRef.MsInput
    };
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        blur: (e) => {
          this.onBlur(e);
        },
        focus: (e) => {
          this.onFocus(e);
        },
        input: (e) => {
          this.$emit("changed", this.internalText);
        },
        keydown: (e) => {
          // event.stopPropagation();
          this.onKeyDown(e);
        },
        mouseup: (e) => {
          this.onMouseUp(e);
        },
        keyup: (e) => {
          this.onKeyUp(e);
        },
        focusout: (e) => {
          this.onFocusOut(e);
        },
      };
    },
    isEditingMode() {
      return this.$store.getters.getEditingMode;
    },
  },
  watch: {
    internalText: {
      handler(newVal, oldVal) {
        const me = this;
        if (
          this.internalText &&
          this.maxLength &&
          this.internalText.toString().length > this.maxLength
        ) {
          this.internalText = this.internalText.slice(0, this.maxLength);
        }
        if (me.isResetValidate) me.validate(newVal);
        me.$emit("input", newVal);
      },
    },
    value: {
      handler(newVal, oldVal) {
        const me = this;
        me.setValue(newVal);
      },
    },
    /**
     * custom validate
     */
    paramValidate(val) {
      let me = this;
      //Nếu validate đang true và kphai custom thì return
      if (
        me.errorProvider &&
        me.errorProvider["isValid"] &&
        (!val || (val && me.errorProvider["rules"] != val.rules))
      ) {
        return;
      }

      if (val && val.isValid) {
        me.$set(me.errorProvider, "message", val.message);
        me.$set(me.errorProvider, "isValid", true);
        me.errorProvider.rules = val.rules;
        me.errorProvider.element = me.$refs[this.controlFocusRef];
      } else {
        me.errorProvider = {};
      }
    },
    editable: {
      immediate: true,
      handler(val) {
        !this.globalPopup && this.$store.dispatch("setEditingMode", false);
        this.editingMode = !val;
      },
    },
  },
  mounted() {
    if (this.autofocus) {
      this.$nextTick(() => this.$refs[this.controlFocusRef].focus());
    }
  },
  methods: {
    /**
     * @override
     */
    focusError(){
      this.$refs[this.controlFocusRef].focus();
    },
    /**
     * Sự kiện nhấp chuột
     */
    onMouseUp(e) {
      this.$emit("mouseup", e);
    },
    onKeyUp(e) {
      this.$emit("keyup", e);
    },
    onFocusOut(e) {
      this.$emit("focusout", e);
    },
    /**
     * Sự kiện input thay đổi
     * Created by thduong 19/3/2021
     */
    onChangeValue(e) {
      this.$emit("valueChange", this.$refs[this.controlFocusRef].value, e);
      this.$emit("onChange", this.$refs[this.controlFocusRef].value);
      this.$emit("onChangeInput", e);
    },
    /**
     * Sự kiện double click để sửa nhanh input
     * Created by thduong 19/3/2021
     */
    onDoubleClick() {
      this.permission && this.clickEditBtn();
    },
    //Sự kiện focus vào ô input
    onKeyDown(e) {
      const me = this;
      me.$emit("keydown", e);
    },
    //Sự kiện focus vào ô input
    onFocus(e) {
      const me = this;
      me.focused = true;
      me.$emit("focus", e);
    },
    //Sự kiên blur ra ngoài ô input
    onBlur(e) {
      const me = this;
      me.focused = false;
      me.$emit("blur", e);
    },
    //Reset lại giá trị về ban đầu
    reset() {
      const me = this;
      me.internalText = null;
    },
    //Set giá trị cho ô input
    setValue(value) {
      const me = this;
      me.internalText = value;
    },
    focusInput() {
      this.$refs[this.controlFocusRef].focus();
    },
    /**
     * Hàm xử lý khi click icon edit
     * created by pdthien 21.01.2021
     */
    clickEditBtn() {
      if (!this.isEditingMode) {
        this.oldValue = this.value;
        this.editingMode = !this.editingMode;
        this.$nextTick(() => this.$refs[this.controlFocusRef].focus());
        this.$emit("clickEditBtn");
        this.$store.dispatch("setEditingMode", true);
      }
    },
    /**
     * Hàm xử lý khi đóng chế độ edit
     * created by pdthien 21.01.2021
     */
    closeEditMode() {
      this.editingMode = false;
      this.$store.dispatch("setEditingMode", false);
      this.value = this.oldValue;
      this.$emit("closeEditMode");
    },
    /**
     * Hàm xử lý khi đóng chế độ edit không emit (dùng cho MsFormula)
     * created by pdthien 21.01.2021
     */
    closeEditModeWithoutEmit() {
      this.editingMode = false;
      this.value = this.oldValue;
    },
    /**
     * Hàm xử lý khi lưu edit
     * created by pdthien 21.01.2021
     */
    saveEditMode() {
      if (!this.errorProvider.isValid) {
        this.$emit("onSaveData");
      }
    },
    /**
     * Hàm set editingMode = false
     */
    closeEditingMode() {
      this.editingMode = false;
      this.$store.dispatch("setEditingMode", false);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/controls/msInput.scss";
</style>
<style lang="scss">
.text-border {
  p {
    display: flex;
    flex-direction: column-reverse;
    padding-left: 8px;
  }
  .mi-pencil {
    opacity: 0;
  }
  &:hover {
    .mi-pencil {
      opacity: 1;
    }
  }
  .mi-lock {
    opacity: 0;
  }
  &:hover {
    .mi-lock {
      opacity: 1;
    }
  }
}
</style>

